var _Path, _Path2, _Path3, _Path4, _Path5, _Path6, _Path7, _Path8, _Path9, _Path10, _Path11, _Path12;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgStrengthAssessmentBodyGroupsFemale(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 190,
    height: 192,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M56.9 127.377c.787-3.983 1.574-7.918 2.41-12.049a651.305 651.305 0 01-2.41 12.049z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.492,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement(Path, {
    d: "M54.392 109.476c2.558-6.689 2.263-13.721 1.87-20.705 0-.147-.197-.246-.345-.492-.492.246-1.033.394-1.377.738a339.89 339.89 0 00-7.918 6.787c-.541.492-.885 1.377-.934 2.115-.69 8.213-.05 16.328 1.82 24.344.639 2.705 1.18 5.361 1.77 8.065h.442c.443-2.655.935-5.36 1.23-8.016.54-4.475 1.82-8.656 3.442-12.836zM39.343 96.148c-1.476-1.525-2.951-3.099-4.574-4.476-1.574-1.328-3.394-2.41-5.115-3.59-.148.098-.295.246-.443.344-.344 6.148-.836 12.345 1.132 18.246 2.262 6.738 4.327 13.525 4.967 20.607.098.885.393 1.77.59 2.655.147 0 .295 0 .443-.049.393-1.967.737-3.934 1.229-5.852 2.213-8.705 2.902-17.508 2.311-26.41 0-.492-.196-1.131-.54-1.475z",
    fill: props.colorFive,
    stroke: "#fff",
    strokeWidth: 0.492,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    d: "M32.703 35.41c1.721-.246 3.05-.836 3.59-2.36 1.476-3.935 1.082-7.722-.885-11.41-.492-.886-1.131-2.066-.934-2.902.639-2.41 1.672-4.77 2.606-7.082.935-2.263 2.017-2.656 4.328-1.672 2.164.934 4.279 2.016 6.492 2.803 1.869.688 2.803 1.77 2.852 3.738 0 .393.099.885.345 1.18 1.278 1.328.639 2.508-.197 3.64-1.77 2.41-2.656 5.016-2.557 8.065.147 4.082 1.72 5.902 6.196 6.54 0-.442.05-.688 0-.983-.098-.688-.197-1.426-.344-2.114a52.019 52.019 0 01-1.77-16.525c.098-1.82 0-3.689-.148-5.508-.197-2.656-1.426-4.82-3.59-6.443-1.87-1.475-3.935-2.065-6.394-2.065-2.213 0-4.032.491-5.36 2.114-.984 1.131-1.918 2.508-2.263 3.935-1.328 5.164-2.016 10.426-1.77 15.787.147 2.803 0 5.655 0 8.508.049.934-.099 1.82-.197 2.754z",
    fill: "#666",
    stroke: "#fff",
    strokeWidth: 0.492,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement(Path, {
    d: "M35.458 81.738c-.934-8.213-2.36-16.426-1.278-24.737.049-.394.098-.935-.148-1.18-1.77-1.771-3.59-3.443-5.41-5.165-.344.64-.393 1.033-.344 1.427.64 2.95 1.18 5.901 1.967 8.803 1.476 5.557 2.017 10.967-.737 16.377-1.377 2.655-2.213 5.606-3.246 8.36 2.557 1.377 5.016 2.46 7.13 3.984 2.165 1.574 4.034 3.64 6.05 5.46.394.343.836.59 1.23.884.098-.098.147-.196.245-.295-2.163-2.213-3.54-4.918-4.278-7.869-.541-1.967-.984-4.032-1.18-6.049zM55.474 75.492c-1.082-2.803-1.771-5.656-1.132-8.656.738-3.54 1.623-7.032 2.41-10.524.344-1.721.541-3.541.787-5.262-.197-.099-.393-.197-.59-.246a510.709 510.709 0 01-5.46 5.213c.1 1.18.247 2.262.345 3.295.443 7.918-.688 15.688-1.672 23.459-.59 4.77-1.967 9.246-5.164 13.131 4.279-4.082 8.46-8.311 14.607-9.934-1.476-3.64-2.804-7.082-4.131-10.476z",
    fill: props.colorEight,
    stroke: "#fff",
    strokeWidth: 0.492,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), _Path3 || (_Path3 = /*#__PURE__*/React.createElement(Path, {
    d: "M49.032 14.312c-2.902-1.328-5.803-2.656-8.803-3.787-.492-.197-1.672.245-1.869.688-.984 2.164-1.77 4.476-2.262 5.803.295 4.82 1.426 8.115 4.524 10.525 1.525 1.23 2.951 1.328 4.574.393 4.328-2.459 5.656-9 4.525-12.688-.099-.394-.394-.787-.689-.934z",
    fill: "#666",
    stroke: "#fff",
    strokeWidth: 0.492,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement(Path, {
    d: "M33.59 147.147c-2.41 3.886-3.394 7.918-3.886 12-.64 5.459-1.18 10.919-1.77 16.378-.05.59-.246 1.131-.394 1.721-.196 0-.393-.049-.59-.049-.197-9.787-3.738-19.23-3.098-29.115-1.279 4.328-1.033 8.606-.443 12.983.738 5.509.984 11.066 1.328 16.623.05.738 0 1.476-.147 2.164 1.032-.442 3.049-.885 4.77 1.722 0-1.427.541-2.853.64-4.279.344-4.18 1.229-7.77 2.606-11.361 2.164-5.655 1.426-11.409 1.23-17.409 0-.394-.099-.738-.246-1.378z",
    fill: props.colorFive,
    stroke: "#fff",
    strokeWidth: 0.492,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), _Path4 || (_Path4 = /*#__PURE__*/React.createElement(Path, {
    d: "M24.589 180.934c-.295 1.525-1.082 2.902-2.213 4.131-.787.836-1.476 1.722-2.115 2.607-.886 1.279-.443 2.361 1.082 2.557 1.721.197 3.442.295 5.114.246 2.017-.098 2.804-1.033 2.804-3.098-.05-1.574.049-3.099.098-4.672-1.721-2.656-3.738-2.213-4.77-1.771zM64.033 186.148a11.217 11.217 0 01-3.148-5.508c-2.41-1.18-4.033.639-4.672 1.623 0 1.77.147 3.541.098 5.311-.049 1.771.787 2.607 2.508 2.804a15.13 15.13 0 003.345-.099c1.18-.147 2.705.443 3.344-.983.64-1.427-.64-2.312-1.475-3.148z",
    fill: "#666",
    stroke: "#fff",
    strokeWidth: 0.492,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement(Path, {
    d: "M60.934 179.607c-.345-1.377-.394-2.853-.246-4.377.442-5.115 1.082-10.23 1.573-15.345.197-2.311.443-4.573.394-6.885 0-1.574-.443-3.098-.689-4.672-.196 0-.393 0-.54.049.934 9.836-2.509 19.181-2.804 28.869-.197 0-.393 0-.54-.049-.1-.295-.296-.639-.296-.935-.541-4.721-.984-9.393-1.623-14.114-.393-3.099-.836-6.197-1.574-9.246-.492-1.967-1.524-3.787-2.36-5.656-.148.049-.246.098-.394.148-.344 6.246-1.18 12.344 1.082 18.295 1.426 3.737 2.41 7.082 2.705 11.705.098 1.327.64 2.557.689 3.836.59-.984 2.163-2.853 4.623-1.623z",
    fill: props.colorFive,
    stroke: "#fff",
    strokeWidth: 0.492,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M24.688 47.853c.491.246.737.492 1.082.59 2.557.836 4.524 2.508 6.344 4.377 2.95 3.099 4.918 3.541 9.098 1.869 0-2.803.295-5.656-.05-8.41-.54-4.475-2.212-5.901-6.638-6.836-1.623-.344-3-.147-4.033 1.082-2.017 2.36-3.886 4.82-5.803 7.328zM60.933 48.098c-1.426-2.066-2.607-3.836-3.836-5.606-2.262-3.246-4.18-3.935-7.869-2.46-1.377.59-3 1.574-3.689 2.804-1.967 3.787-1.377 7.918-1.13 12 .934.197 1.672.344 2.41.492 1.917.393 3.786.442 5.31-1.132 2.558-2.508 4.968-5.213 8.804-6.098z",
    fill: props.color,
    stroke: "#fff",
    strokeWidth: 0.492,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M78.244 91.623c-3-8.066-4.82-19.721-9.54-27.541l-1.476 2.95c-1.574-.737-2.95-1.425-4.82-2.31.738 10.13 8.41 20.016 12.05 28.475 1.327-.443 2.262-.787 3.245-1.131.05-.05.148-.148.541-.443zM23.014 64.82c-1.623.786-3.05 1.426-4.574 2.163-.541-1.082-.984-1.868-1.475-2.852-4.77 7.918-6.59 18.885-9.787 27.147 1.377.394 2.41.738 3.64 1.082.245-.295.54-.639.786-1.032 2.213-4.132 5.852-10.033 7.82-14.263 1.475-3.196 2.459-6.64 3.59-9.983.197-.59 0-1.377 0-2.263z",
    fill: props.colorSix,
    stroke: "#fff",
    strokeWidth: 0.492,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M27.195 171.541c.196 0 .393.049.54.049.148-1.18.394-2.41.443-3.59.541-7.623.935-15.197 4.918-22.131.541-.984-.147-3.59-1.082-4.23-1.082-.737-1.869-1.623-2.852-2.409-1.328-1.033-3-.886-3.59.639-.64 1.623-1.18 3.393-1.23 5.115-.049 2.803.197 5.655.541 8.459.689 6.049 1.525 12.049 2.312 18.098zM55.77 139.869c-.541.59-1.377.934-2.017 1.426-.246.148-.492.344-.59.59-.738 1.623-1.426 3.197-.344 5.017 2.41 4.082 3.59 8.606 3.934 13.327.295 3.689.64 7.427.935 11.115.197 0 .442.049.64.049.737-5.508 1.573-10.967 2.212-16.475.295-2.557-.049-5.262.394-7.77.393-2.263.196-4.328-.541-6.443-.935-2.41-2.902-2.754-4.623-.836z",
    fill: props.colorFive,
    stroke: "#fff",
    strokeWidth: 0.492,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), _Path5 || (_Path5 = /*#__PURE__*/React.createElement(Path, {
    d: "M43.474 52.082c.148-2.41.197-4.82.492-7.23.344-3 2.312-4.671 5.017-5.606.885-.295 1.82-.443 2.754-.738.491-.147.934-.344 1.377-.491-.05-.148-.099-.246-.148-.394-2.803-.098-5.311 1.131-8.016 2.36.737-4.622 3.049-8.507 2.852-12.59-1.77.64-3.492 1.722-5.115 1.624-1.622-.099-3.147-1.476-4.77-2.312-.246 4.426 1.918 8.558 2.852 13.476-2.803-1.525-5.311-2.558-8.163-2.312a9.923 9.923 0 002.852 1.033c3.738.885 6.148 3 6.393 6.983.148 2.46.197 4.968.295 7.427.05.787-.098 1.72 1.377 1.426-.049-.885-.098-1.77-.049-2.656z",
    fill: "#666",
    stroke: "#fff",
    strokeWidth: 0.492,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement(Path, {
    d: "M62.506 49.083c-1.426-.541-2.41.147-3.443.639-.393.197-.64 1.18-.59 1.77.148 1.918.246 3.935.787 5.754 1.131 3.984 3.295 7.18 7.672 8.656 1.377-2.705 1.18-5.41.984-8.115-.345-3.737-1.23-7.18-5.41-8.704zM26.459 57.295c.54-1.869.639-3.836.786-5.754.05-.59-.196-1.574-.59-1.77-1.033-.492-2.016-1.18-3.442-.64-4.18 1.525-5.066 4.968-5.361 8.754-.197 2.705-.393 5.41.984 8.115 4.278-1.574 6.491-4.77 7.623-8.705z",
    fill: props.colorSix,
    stroke: "#fff",
    strokeWidth: 0.492,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M28.524 100.722c-.05-.738-.197-1.426-.345-2.36-2.311 3.442-2.754 5.212-2.163 9.639.59 4.819 1.475 9.59 2.36 14.36.344 1.918 1.033 3.836 1.574 5.754.148-.049.295-.098.492-.147.442-1.525.737-3.098 1.426-4.525 1.869-3.787 1.279-7.426-.393-11.065-1.673-3.689-2.705-7.574-2.951-11.656z",
    fill: props.colorFive,
    stroke: "#FFF",
    strokeWidth: 0.492,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M55.573 128.017c.295-1.033.689-2.066.935-3.098 1.672-6.541 2.852-13.181 3.098-19.918.099-2.312-.64-4.377-2.262-6.492-.148.934-.246 1.623-.295 2.311-.246 3.886-1.23 7.574-2.754 11.115-.492 1.18-1.033 2.41-1.328 3.639-.295 1.377-.64 2.853-.344 4.181.639 2.754 1.672 5.459 2.557 8.164.147.049.246.098.393.098z",
    fill: props.colorFive,
    stroke: "#fff",
    strokeWidth: 0.492,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M43.277 78.738v16.869c5.558-4.968 5.951-11.656 6.64-18.296-2.361.492-4.427.935-6.64 1.427zM42.244 95.902V78.69c-2.213-.491-4.23-.983-6.54-1.475.786 6.64 1.081 13.328 6.54 18.688z",
    fill: props.colorSecondary,
    stroke: "#fff",
    strokeWidth: 0.492,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M26.063 44.852c1.574-2.36 3-4.82 5.754-6.246-2.607-2.213-5.852-2.508-7.77-.934-3.787 3.197-4.673 7.426-4.328 12.246 2.95-.885 4.82-2.803 6.344-5.066z",
    fill: props.fill,
    stroke: "#fff",
    strokeWidth: 0.492,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M31.916 131.803c-1.426-1.672-2.557-3.688-4.72-4.032-.886 3.885-1.771 7.819-2.706 11.754.099.098.246.147.345.246 1.13-1.771 2.213-3.541 3.344-5.361l.295.147c-.344 1.033-.689 2.066-.935 2.853 1.28.885 2.509 1.721 3.738 2.557.098-.885.246-1.721.344-2.606.197 0 .345-.05.541-.05-.196 1.968.246 3.689 1.476 4.869.688-3 1.377-6.049 2.114-9.393-1.967 1.279-2.95.098-3.836-.984zM53.95 137.213c.147 1.082.245 1.919.393 2.705a113.55 113.55 0 003.59-2.557c-.246-.836-.59-1.82-.886-2.852.099-.05.197-.05.296-.099 1.082 1.722 2.213 3.492 3.295 5.213.098-.049.196-.147.295-.196-.886-3.935-1.77-7.82-2.656-11.705-2.016.491-3.197 2.213-4.525 3.885-.934 1.18-1.967 2.459-3.885 1.377.689 3.492 1.279 6.836 1.918 10.082.738-1.771 1.427-3.689 2.164-5.853z",
    fill: props.colorFive,
    stroke: "#fff",
    strokeWidth: 0.492,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M60.196 45.64c1.426 1.917 3.147 3.491 5.704 4.327.246-4.328-.344-8.213-3.442-11.41-2.312-2.36-5.803-2.41-8.558.05 3.05 1.524 4.377 4.524 6.296 7.032z",
    fill: props.fill,
    stroke: "#fff",
    strokeWidth: 0.492,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), _Path6 || (_Path6 = /*#__PURE__*/React.createElement(Path, {
    d: "M5.753 93.886C4.08 95.214 2.31 96.443.49 97.77c.836.885 1.672-.099 2.951-.197-.885 2.41-1.623 4.377-2.36 6.394.049.049-.197.541.245.344l2.312-3.541c.098.049.196.098.344.147-.393 1.23-1.033 2.853-1.426 4.033.049.049-.099.787.54.049.69-1.278 1.28-2.901 1.919-4.18.197.098.344.148.54.246.05.049-1.13 3.836-1.229 4.18l.394.049c.098-.049.147-.147.196-.196.148-.197.246-.394.345-.64.147-.344.295-.737.442-1.082.099-.196.64-1.327.738-1.524.541-.689.394-.443.738-.836.098-.049.196-.099.344-.099-.098.886-.098 2.263-.197 3.099.148.049.394 0 .541.049 1.131-3.934 1.279-6.492 2.41-10.328-1.033-1.033-2.213-1.82-3.147-1.475-.59.147-1.082 1.377-1.377 1.623zM85.276 97.82c-3.147-2.36-5.459-1.23-7.033-5.016-1.13.344-2.114.688-3.147.983 1.23 3.984.492 6.738 2.655 10.623.59-.344-.147-3-.147-3.787.787.295 1.328.984 1.77 1.722.296.59.541 1.278.886 1.819.245.541.491.886.737.836.59-.491-1.377-2.557-.688-4.573.787 1.426 1.623 3.393 2.213 4.475.64.394.443-.246.54-.246-.294-.934-.983-2.803-1.327-3.836l.295-.147c.59.934 1.475 2.803 2.016 3.541.197.295.394.098.345-.246-.394-2.164-2.017-3.886-1.623-6.345.737.246 1.721 1.082 2.508.197z",
    fill: "#666"
  })), /*#__PURE__*/React.createElement(Path, {
    d: "M51.097 62.95c-.148-2.213-.295-4.377-.393-6.393-1.525-.147-2.705-.295-3.886-.393-1.13-.148-2.262-.295-3.54-.492v7.82c2.655-.148 5.163.688 7.819-.541zM34.572 63.345h7.672v-7.623c-2.459.246-4.72.54-7.328.787-.098 2.114-.196 4.327-.344 6.836zM51.097 64.427h-7.82v6.098h7.427c.147-2.262.295-4.279.393-6.098zM42.196 64.377h-7.673c.148 1.967.295 3.934.443 6.246h7.23v-6.246z",
    fill: props.colorSecondary,
    stroke: "#fff",
    strokeWidth: 0.492,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M25.866 87.099c-1.475 4.967-1.18 10.082-1.18 15.147 2.017-2.852 3.836-5.754 3.541-9.393-.098-1.131 0-2.263.099-3.344.147-2.066-.099-2.361-2.46-2.41zM59.605 86.804c-.934.295-1.672.54-2.458.787.098 5.311-.246 10.475 3.885 14.754-.295-5.312.295-10.377-1.426-15.541z",
    fill: props.colorFive,
    stroke: "#fff",
    strokeWidth: 0.492,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M49.72 75.886c.197-.099.443-.443.443-.689.147-1.18.196-2.41.344-3.787-2.557.099-4.82.246-7.23.344v5.509c2.508.491 4.525-.296 6.443-1.377zM35.359 74.213c.098.59.197 1.475.59 1.721 1.869 1.18 3.885 1.82 6.295 1.377v-5.705h-7.082c.05.886.05 1.722.197 2.607z",
    fill: props.colorSecondary,
    stroke: "#fff",
    strokeWidth: 0.492,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M50.113 132c.541.148 1.476.59 1.722.344.983-.983 2.41-2.114 2.41-3.245 0-2.509-.738-5.066-2.263-7.623-.64 3.639-1.23 6.885-1.869 10.524zM32.9 131.754c.983.935 1.77 1.082 2.459-.098-.59-3.345-1.131-6.59-1.721-9.787-.148-.049-.295-.049-.492-.098-.59 1.868-1.082 3.786-1.722 5.606-.639 1.918.246 3.148 1.476 4.377z",
    fill: props.colorFive,
    stroke: "#fff",
    strokeWidth: 0.492,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M47.801 32.41c-.54 1.967-1.13 3.885-1.72 5.951 2.31-.59 4.376-1.18 6.884-1.869-2.41-.738-4.278-1.77-5.164-4.082zM37.867 32.608c-.098-.05-.245-.099-.344-.148-.64 2.41-2.557 3.295-4.869 4.033 2.508.688 4.574 1.23 6.885 1.82-.59-2.017-1.13-3.837-1.672-5.706z",
    fill: props.colorSeven,
    stroke: "#fff",
    strokeWidth: 0.492,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M25.375 117.787c.246 2.41.59 4.82 1.033 7.18.197.935 1.377 1.771 1.82 2.656.147-.098.246-.147.393-.246-1.18-6.098-2.36-12.147-3.59-18.59.295 3.246 0 6.098.345 9z",
    fill: props.colorFive,
    stroke: "#fff",
    strokeWidth: 0.492,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), _Path7 || (_Path7 = /*#__PURE__*/React.createElement(Path, {
    d: "M59.31 122.017c-.541 2.901-1.377 4.77-2.36 5.36.983-.59 1.77-2.459 2.36-5.36zM59.606 119.951a65.53 65.53 0 01-.296 1.771 9.483 9.483 0 00.296-1.771z",
    fill: "#B8B8B8",
    stroke: "#fff",
    strokeWidth: 0.492,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement(Path, {
    d: "M59.802 122.017c0-.098.64-5.065.689-6.049.098-1.475-.345-3.098-.345-4.82-.295 1.427-.54 2.804-.836 4.181-.836 4.131-1.623 8.115-2.41 12.049 1.033-.59 2.312-2.459 2.902-5.361z",
    fill: props.colorFive,
    stroke: "#fff",
    strokeWidth: 0.492,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), _Path8 || (_Path8 = /*#__PURE__*/React.createElement(Path, {
    d: "M140.163 30.836c1.771-.344 3.541-.688 5.262-1.082 3.984-.983 8.066-2.655 10.427-6 2.262-3.196 2.606-7.426 2.409-11.36-.098-2.558-.442-5.164-1.672-7.427-2.606-4.82-9.246-5.459-13.377-2.262-2.016 1.574-3.491 3.787-4.623 6.099-3.639 7.377-4.426 15.737-5.114 23.95 2.164-.983 4.426-1.475 6.688-1.918z",
    fill: "#666",
    stroke: "#fff",
    strokeWidth: 0.492,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement(Path, {
    d: "M147.588 32.804c-3.59.541-7.229 1.131-10.967 1.77.049.099.098.345.246.492 2.016 2.656 3.098 5.656 3.492 8.951.295 2.263.492 4.623 1.033 6.836.541 2.213 1.18 4.476 2.311 6.443 1.475 2.557 3.443 4.869 5.115 7.23 1.131-1.525 2.262-3.099 3.492-4.623 2.36-2.853 3.688-6.099 4.18-9.787.443-3.443 1.033-6.886 1.869-10.28.492-1.917 1.721-3.638 2.557-5.31-3.787-.59-7.623-1.23-11.459-1.82-.59-.099-1.229 0-1.869.098z",
    fill: props.colorSeven,
    stroke: "#fff",
    strokeWidth: 0.492,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M156.49 108.541c5.853-.197 10.722-6.836 9.05-12.492-1.033-3.393-2.41-6.639-5.115-9.196-1.476-1.427-2.951-1.722-4.771-1.328-4.229.836-6.344 3.393-6.344 7.672v3.393h-.197c.197 2.213.148 4.525.689 6.689.836 3.639 3.246 5.36 6.688 5.262zM148.327 92.164c-.049-4.279-4.82-7.918-9-6.885-.246.049-.443.147-.64.295-3.295 2.41-7.967 9.393-6.245 14.901.344 1.082.639 2.164 1.082 3.197 1.18 3.098 4.573 5.017 8.311 4.869 3.295-.148 5.262-1.721 6.098-5.41.492-2.115.394-4.328.591-6.492h-.148c-.049-1.524 0-3-.049-4.475z",
    fill: props.colorFour,
    stroke: "#fff",
    strokeWidth: 0.492,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M157.72 84.246c-.442-.64-.639-.983-.934-1.279-1.918-2.114-2.754-4.573-2.361-7.377.541-3.983-1.18-6.737-4.475-8.705-.836-.491-1.427-.491-2.263 0-3.344 1.968-4.967 4.77-4.426 8.705.344 2.804-.492 5.263-2.36 7.377-.296.296-.492.738-.837 1.328 3.886.394 7.132 1.525 8.853 5.508 1.623-4.081 4.967-4.967 8.803-5.557z",
    fill: props.colorEight,
    stroke: "#fff",
    strokeWidth: 0.492,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), _Path9 || (_Path9 = /*#__PURE__*/React.createElement(Path, {
    d: "M167.014 179.951c-.05.64-.099 1.181-.148 1.673-.197 0-.393 0-.59-.05-.394-1.623-.541-1.327-.59-2.754l-1.771 2.459c-.541.787-1.721.738-2.213-.049l-1.18-1.82c.098 2.066-.099 2.41-.64 4.82-.491 2.213.443 4.18 1.574 6 .836 1.279 2.164 1.377 3.492 1.082 1.131-.295 2.311-.738 2.508-2.164.246-1.819.59-3.639.738-5.459.147-1.328.147-2.705-1.18-3.738z",
    fill: "#666",
    stroke: "#fff",
    strokeWidth: 0.492,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement(Path, {
    d: "M161.703 180.147c.492.787 1.673.836 2.214.05l1.77-2.459c-.098-5.115 1.426-11.41 1.23-17.214-1.23 1.771-2.607 1.968-4.279 1.082-.344-.196-1.033.148-1.574.345-1.033.344-2.065.787-3.443 1.328 0-.197-.049-.05 0 .147.197.787.345 1.623.591 2.41 1.229 3.934 2.164 9 2.311 12.492l1.18 1.819zM135.047 161.607c-1.672.885-3.049.59-4.328-1.18 0 .688-.049 1.033 0 1.377.394 4.131.885 6.393 1.131 10.524a92.487 92.487 0 010 5.214l1.525 2.409c.492.787 1.672.836 2.213.05l1.475-2.066c-.049-1.721.099-5.016.541-6.738.591-2.164 1.181-2.508 1.722-4.672.295-1.229.541-2.459.688-3.295-1.377-.541-2.36-.984-3.442-1.328-.443-.147-1.132-.492-1.525-.295z",
    fill: props.colorFive,
    stroke: "#fff",
    strokeWidth: 0.492,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), _Path10 || (_Path10 = /*#__PURE__*/React.createElement(Path, {
    d: "M137.064 179.016l-1.475 2.066c-.541.787-1.721.738-2.213-.049l-1.525-2.41c-.049 1.23-.147 2.41-.196 3.639 0 .394-.836-1.623-.836-2.459-1.574 1.377-1.525 2.853-1.279 4.328.197 1.426.541 2.804.688 4.181.197 1.819.886 2.655 2.656 3 1.672.344 2.902-.246 3.738-1.673 1.082-1.967 1.574-3.983 1.18-6.295-.344-1.967-.688-2.311-.738-4.328z",
    fill: "#666",
    stroke: "#fff",
    strokeWidth: 0.492,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement(Path, {
    d: "M155.161 77.361c.099 2.263 1.181 3.984 2.656 5.46a216.206 216.206 0 002.803-6.1c.148-.393.049-.934-.049-1.376-.738-2.803-.738-5.607-.147-8.41.885-4.328 1.721-8.656 2.557-12.934-2.016-.345-3.984-.64-6.197-1.033-.787 3.688-3.098 6.59-5.459 9.492-.738.934-1.18 2.065-1.77 3.098.885.688 1.475 1.18 2.114 1.574 2.804 1.77 3.787 4.377 3.591 7.573-.05.886-.099 1.771-.099 2.656zM146.26 66.934c.64-.393 1.18-.934 1.918-1.475-2.115-4.525-6.541-7.623-7.229-12.541-2.164.344-4.131.688-6.197 1.033.049.295.049.688.098 1.082.787 3.836 1.525 7.623 2.312 11.459.639 3 .688 5.95-.099 8.95-.098.443-.147.984.05 1.378.836 1.967 1.77 3.934 2.705 5.901 2.213-1.918 2.901-4.377 2.606-7.278-.344-3.541.639-6.492 3.836-8.509z",
    fill: props.colorEight,
    stroke: "#fff",
    strokeWidth: 0.492,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M159.047 108.935c0 .491-.049.688-.049.836l.295 1.18c1.426 4.623 2.066 9.344 2.213 14.164.148 4.131 1.722 7.918 3.787 11.459.049.049.197.049.246.049 2.508-12.541 3.344-25.131 1.131-37.918-.934 4.771-2.508 8.853-7.623 10.23zM137.114 115.427c.393-2.115 1.032-4.23 1.573-6.443-5.262-1.426-6.688-5.557-7.622-10.18-2.41 12.737-1.279 25.377 1.032 37.918-.049 0 .099 0 .148-.049.246-.345.442-.689.639-1.033 1.918-4.033 3.295-8.164 3.295-12.738.049-2.557.492-5.065.935-7.475z",
    fill: props.colorFive,
    stroke: "#fff",
    strokeWidth: 0.492,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M175.326 67.673c-2.361.787-4.377-.246-4.721 0-1.771 1.23-.689 2.95-.541 4.475.491 5.36 2.459 10.328 4.327 15.295.886 2.36 3.099 7.574 4.082 9.836 1.476-.64 2.656-1.13 4.033-1.721-1.377-8.36-2.459-20.115-7.18-27.885zM127.08 67.721c-.344-.246-2.164.59-4.819.099-4.722 7.672-5.41 18.934-6.935 27.344 1.328.442 2.41.836 3.885 1.328.541-1.082 2.017-4.574 2.509-5.754 2.606-6.246 5.164-12.492 5.803-19.28.147-1.327.934-2.704-.443-3.737z",
    fill: props.colorSix,
    stroke: "#fff",
    strokeWidth: 0.492,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M161.557 142.721c.393-4.475 1.131-8.754-.049-13.033-.492-1.77-.639-3.59-.836-5.41-.295-2.409-.344-4.819-.689-7.229-.295-2.016-.885-3.934-1.426-6.295-3.541 8.606-4.918 28.328-2.557 35.705 1.524-1.771 2.754-3.885 5.557-3.738zM136.867 123.836c-.05 1.869-.345 3.787-.787 5.607-1.082 4.426-.492 8.754-.099 13.279 2.804-.099 4.082 1.967 5.656 3.885 2.115-12.246 1.426-24-2.606-35.508-1.377 4.082-1.968 8.36-2.164 12.737z",
    fill: props.colorFive,
    stroke: "#fff",
    strokeWidth: 0.492,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M123.59 67.328c.295-.05.541-.05.836-.098 1.868.098.737.098 2.705 0 3.688-3.541 6.196-16.476 4.278-20.213-1.18.245-2.41.442-3.59.737-2.115.541-3.492 1.77-4.082 3.984-1.18 4.426-.983 8.902-.934 13.377.049.738.541 1.475.787 2.213zM168.097 47.361c-.59-.098-1.131-.246-1.819-.393-1.869 4.033.737 17.164 4.032 20.311h3.197c.197 0 .443 0 .64.05.245-.935.737-1.82.737-2.755 0-3.393.049-6.787-.393-10.13-.64-4.82-1.672-6.296-6.394-7.083z",
    fill: props.fillSecondary,
    stroke: "#fff",
    strokeWidth: 0.492,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M163.524 41.066c.098.049.196.098.344.147 1.377.59 2.115 1.623 2.213 3.099.049.54.147 1.032.197 1.574 2.36.737 4.623 1.426 6.885 2.114 1.279-3.836-.492-8.901-3.984-10.77-2.114-1.131-4.426-1.918-6.639-2.902-3.492 3.885-3.344 4.77.984 6.738zM131.556 45.886c-.245-2.607.837-4.328 3.246-5.066.246-.049.443-.197.64-.295 2.41-1.23 2.705-2.262 1.18-4.377-.393-.59-.885-1.082-1.377-1.721-2.262.983-4.475 1.77-6.59 2.852-3.59 1.82-5.459 6.935-4.131 10.82 2.409-.787 4.672-1.475 7.032-2.213z",
    fill: props.fill,
    stroke: "#fff",
    strokeWidth: 0.492,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M132.49 138.639c-.197-.049-.443-.049-.64-.098-.245.689-.639 1.328-.786 2.016-.443 1.968-.787 3.935-1.132 5.902-.688 4.033-.344 9.738 1.623 13.377.492.885.984 1.623 2.164 1.328 1.181-.295 1.82-.836 1.722-2.213a85.708 85.708 0 01.049-7.967c.246-3.886-1.721-8.902-3-12.345zM162.244 159.394c0 1.082.59 1.426 1.426 1.721.885.345 1.77.246 2.115-.639.786-1.82 1.623-3.688 2.016-5.606.984-4.574-.934-10.722-1.525-15.099-.049-.393-.491-.738-.737-1.131-.246 0-.443-.049-.689-.049-.885 2.754-2.262 5.508-2.606 8.36-.443 3.443 0 8.902 0 12.443z",
    fill: props.colorFive,
    stroke: "#fff",
    strokeWidth: 0.492,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M137.606 52.869c.541-.05 1.032-.197 1.524-.394 1.033-.344 1.525-.934 1.328-2.114-.393-2.213-.59-4.476-.934-6.689-.246-1.377-.64-2.705-.984-4.131-1.524.885-2.754 1.721-4.082 2.312-1.524.688-2.262 1.77-2.065 3.344.245 1.672.688 3.344 1.082 4.967.786 2.902 1.082 3.098 4.131 2.705zM162.489 52.87c.344-.05.935-.296.984-.542.639-2.606 1.278-5.262 1.721-7.868.197-1.033-.541-1.82-1.574-2.312-1.475-.738-2.852-1.574-4.426-2.41-.147.492-.393 1.082-.541 1.672-.492 2.656-.934 5.361-1.328 8.017-.344 2.557.197 3.197 2.853 3.492.787.049 1.573.049 2.311-.05z",
    fill: props.colorSeven,
    stroke: "#fff",
    strokeWidth: 0.492,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), _Path11 || (_Path11 = /*#__PURE__*/React.createElement(Path, {
    d: "M188.703 109.131c.099-.098.246-.147.345-.246-.738-1.967-2.705-3.344-2.951-5.95.983.541 1.819 2.016 2.262 1.278-2.951-3.098-3.295-5.459-5.803-7.82-1.426.69-2.459 1.18-3.836 1.82 1.377 2.705-.295 5.312-.689 9.394.935.049 1.23-1.476 1.525-2.213.639-1.525 1.082-1.673 1.967-.296.443.689.639 1.525.885 2.263.443 1.328.836 2.656 1.279 3.983l.443-.147c-.246-.836-.541-1.672-.689-2.508-.147-.836-.197-1.722-.295-2.607.246-.098.492-.147.738-.246 1.082 1.721 1.869 3.295 2.951 4.967.049-.049.295-.147.344-.196-.738-1.918-1.426-3.59-2.164-5.509l.59-.295a110.648 110.648 0 003.098 4.328z",
    fill: "#666"
  })), /*#__PURE__*/React.createElement(Path, {
    d: "M136.228 143.509c0 5.016-.099 11.705.098 16.524.049.689 1.328 1.476 2.213 1.918.246.099 1.23-.737 1.525-1.327 1.672-3.148 1.967-6.541 1.475-9.984-.295-2.213-2.705-6.541-5.311-7.131zM159.489 161.951c1.082-.492 2.017-1.132 1.968-2.607-.099-2.902-.049-5.803-.099-8.656-.049-1.721-.147-5.262-.295-7.475-1.082.59-1.77.836-2.311 1.328-1.574 1.377-2.656 4.869-2.754 7.131-.099 3.197.196 6.246 1.623 9.098.393.787.836 1.623 1.868 1.181z",
    fill: props.colorFive,
    stroke: "#fff",
    strokeWidth: 0.492,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), _Path12 || (_Path12 = /*#__PURE__*/React.createElement(Path, {
    d: "M118.917 97.328c-1.328-.492-2.852-1.328-3.541-1.574-1.229 2.066-.787 1.967-1.967 3.54-1.23 1.624-2.705 3.05-4.377 4.821.246.885 1.721-.984 2.41-1.377.147.147.344.295.492.442-.984 1.721-1.968 3.443-3 5.213.098.049.59.197.737.295.984-1.377 1.623-2.852 2.656-4.229l.59.295c-.738 1.918-1.475 3.836-2.262 5.705.049 0 .492.098.59.098 1.033-1.672 1.672-3.393 2.705-5.016.197.098.344.147.541.246.639 1.869-1.721 4.573-.541 5.459.59-1.279 1.033-2.607 1.475-3.935.295-.836.443-1.721.935-2.459.885-1.426 1.524-.59 2.213.935.344.737.098 1.918 1.229 1.524-.196-4.18-3.59-5.655-.885-9.983z",
    fill: "#666"
  })), /*#__PURE__*/React.createElement(Path, {
    d: "M142.768 122.902c.983-5.115 1.868-9.787 2.754-14.262-1.771.344-3.64.639-5.754 1.032.983 4.328 1.918 8.607 3 13.23zM157.769 109.525c-1.279-.098-2.164-.148-3.05-.295-.836-.148-1.672-.492-2.557-.738.935 4.623 1.82 9.099 2.754 13.967.984-4.475 1.918-8.655 2.853-12.934z",
    fill: props.colorFive,
    stroke: "#fff",
    strokeWidth: 0.492,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M137.408 85.476c-4.279-.492-4.918 0-5.705 3.836-.246 1.23-.492 2.41-.639 3.639-.099.934-.099 1.869-.148 2.803.148.05.295.05.393.099 1.427-3.787 2.804-7.623 6.099-10.377zM166.374 95.803c.197-.049.443-.098.64-.098-.443-2.459-.738-4.967-1.279-7.426-.59-2.656-2.656-3.689-5.557-2.656 3.442 2.607 4.77 6.443 6.196 10.18zM136.475 77.311c-1.181 2.656-2.164 4.919-3.295 7.476 2.065-.295 3.787-.492 5.557-.738-.049-2.508-.885-4.524-2.262-6.738z",
    fill: props.colorFour,
    stroke: "#fff",
    strokeWidth: 0.492,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M150.982 29.754c-.934.344-2.016.59-1.18 2.262 2.901.492 5.95.935 9.098 1.476a609.143 609.143 0 01-5.361-4.721c-.737.196-1.623.59-2.557.983z",
    fill: props.colorSeven,
    stroke: "#fff",
    strokeWidth: 0.492,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M164.507 84.737c-1.131-2.508-2.114-4.77-3.098-6.983h-.492c-1.082 1.967-2.065 3.934-1.918 6.344 1.869.197 3.541.394 5.508.64z",
    fill: props.colorFour,
    stroke: "#fff",
    strokeWidth: 0.492,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M148.621 30.541c-3.689.64-7.082.246-9.787 2.557.049.148.049.296.098.443 3-.541 5.951-1.082 8.902-1.672.246-.099.393-.64.787-1.328z",
    fill: props.colorSeven,
    stroke: "#fff",
    strokeWidth: 0.492,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M135.047 142.279c-.147-2.459-.344-4.918-.541-7.623-2.95 2.902-.246 5.164.541 7.623zM162.982 134.656c-.148 2.508-.295 4.869-.443 7.181 1.033-2.312 3.295-4.525.443-7.181z",
    fill: props.colorFive,
    stroke: "#fff",
    strokeWidth: 0.492,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

export default SvgStrengthAssessmentBodyGroupsFemale;